import { Injectable } from '@angular/core';
import { TrinityService } from 'app/services/trinity/trinity.service';
import {
  canUnverifyFileResponse,
  FileHistoryResponse,
  GetFileResponse,
  canUnflagFileResponse,
} from 'app/types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  private readonly endpoint: string = '/file';

  constructor(private trinityService: TrinityService) {}

  get(fileId: string): Observable<GetFileResponse> {
    return this.trinityService.get<GetFileResponse>(
      `${this.endpoint}/${fileId}/google`,
      {
        authorized: true,
      },
    );
  }

  unlockFile(file_id: string): Observable<void> {
    return this.trinityService.post(`${this.endpoint}/${file_id}/unlock`, {
      authorized: true,
    });
  }

  getFileHistory(file_id: string): Observable<FileHistoryResponse> {
    return this.trinityService.get<FileHistoryResponse>(
      `${this.endpoint}/${file_id}/history`,
      {
        authorized: true,
      },
    );
  }

  canUnflagFile(fileId: string): Observable<canUnflagFileResponse> {
    return this.trinityService.get<canUnflagFileResponse>(
      `${this.endpoint}/${fileId}/unflag/permissions`,
      {
        authorized: true,
      },
    );
  }

  canUnverifyFile(fileId: string): Observable<canUnverifyFileResponse> {
    return this.trinityService.get<canUnverifyFileResponse>(
      `${this.endpoint}/${fileId}/unverify/permissions`,
      {
        authorized: true,
      },
    );
  }

  unverifyFile(fileId: string) {
    return this.trinityService.post(`${this.endpoint}/${fileId}/unverify/`, {
      authorized: true,
    });
  }

  syncFile(fileId: string) {
    return this.trinityService.post(`${this.endpoint}/${fileId}/google/sync`, {
      authorized: true,
    });
  }
}
